import React from 'react';
import { motion } from 'framer-motion';
import { Users, PlusCircle, PieChart, ArrowRightLeft, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: <Users className="w-6 h-6 text-kitty-dark" data-id="element-125" data-mp="7qsfh8kyoxeb" />,
  title: 'Create a kitty',
  description: 'Start a shared space for a trip, dinner, house share, event, night out or group plan.'
}, {
  icon: <PlusCircle className="w-6 h-6 text-kitty-dark" data-id="element-126" data-mp="3u0d915s8gavu" />,
  title: 'Add expenses',
  description: 'Add what was paid for, who paid, and who the expense should be shared with.'
}, {
  icon: <PieChart className="w-6 h-6 text-kitty-dark" data-id="element-127" data-mp="qi1shrtxy4an" />,
  title: 'Split fairly',
  description: 'Split equally or enter custom amounts when people owe different shares.'
}, {
  icon: <ArrowRightLeft className="w-6 h-6 text-kitty-dark" data-id="element-128" data-mp="gsrz88nd2fky" />,
  title: 'See the simplest way to settle',
  description: 'KittyPot works out the fewest payments needed to make everyone even.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-129" data-mp="19a4bh9u21wo2" />,
  title: 'Settle up your way',
  description: 'Settle directly however you like, then mark it as paid and confirm when received.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-130" data-mp="2mnwa8v2q9mzh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131" data-mp="31bzb5q1wy8hf">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-132" data-mp="31daiu0yhc0dt">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-133" data-mp="2wjz9nt6737iq">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-134" data-mp="36bbzkf8fnnm4">
            Simple as 1, 2, 3, done.
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-135" data-mp="3k9k1l1kbtf45">
            Create a kitty, add expenses, choose who they're shared with, and
            KittyPot works out who pays who.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-136" data-mp="1pyeufna16kk2">
            Clear costs. Fair splits. Simple settlement.
          </p>
        </div>

        <div className="relative" data-id="element-137" data-mp="3l0ii8a9gtssb">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-138" data-mp="3py1zlj1gmloh"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-4" data-id="element-139" data-mp="3tyu6w6qrugi4">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-140" data-mp="2rrghhirce8y" data-mpi={index}>
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-141" data-mp="lm6fh752k6ws">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-142" data-mp="15nhpy8bpb49l">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-lg font-bold text-kitty-dark mb-2" data-id="element-143" data-mp="rnqiyrjlqo53">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-144" data-mp="1ocg2sneshqtp">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}